define(
    'loader',[
        'order!../lib/jquery/jquery.textarearesizer.compressed.js',
        'order!../lib/underscore/underscore-min.js',
        'order!../lib/backbone/backbone-min.js',
        'order!../lib/jquery/cookie.js',
        'order!../lib/codemirror/codemirror.js',
        'order!../lib/codemirror/css.js',
        'order!../lib/rpc/rpc-get.js',
        'order!../lib/modernizr/modernizr.js'
    ],
    function()
    {
        return {
            Backbone: Backbone.noConflict(),
            _: _.noConflict(),
            $: $,
            Modernizr: Modernizr,
            eventType: (function ()
            {
                if(/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()))
                {
                    return 'touchend';
                }
                return 'click';
            })()
        };
    }
);

